import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "@mui/material"
import { useAuth } from "../services/AuthContext"
import { getPrimaryRole } from "../services/navigationConfig"
import ManagerDashboard from "../components/dashboard/ManagerDashboard"
import AdminDashboard from "../components/dashboard/AdminDashboard"

/**
 * Home Page
 *
 * Role-based home page:
 * - Cashier: redirects to /pos (PosPage routes to selection if needed)
 * - Manager: outlet statistics dashboard
 * - Admin: company-wide statistics dashboard
 */

function HomePage() {
    const { user } = useAuth()
    const navigate = useNavigate()

    const primaryRole = getPrimaryRole(user?.roles)

    useEffect(() => {
        if (primaryRole === "superadmin") {
            navigate("/superadmin/entities", { replace: true })
            return
        }
        if (primaryRole === "cashier") {
            navigate("/pos", { replace: true })
            return
        }
    }, [navigate, primaryRole])

    if (primaryRole === "superadmin") {
        return null
    }

    if (primaryRole === "cashier") {
        return null
    }

    if (primaryRole === "admin") {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <AdminDashboard />
            </Container>
        )
    }

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <ManagerDashboard />
        </Container>
    )
}

export default HomePage
